import { render, staticRenderFns } from "./data-section.vue?vue&type=template&id=d5fc911e&scoped=true&"
import script from "./data-section.vue?vue&type=script&lang=js&"
export * from "./data-section.vue?vue&type=script&lang=js&"
import style0 from "./data-section.vue?vue&type=style&index=0&id=d5fc911e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fc911e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})
